import React, { useState, useCallback, useEffect } from 'react';
import { Button } from "baseui/button";
import { Spinner, SIZE } from "baseui/spinner";
import { useDispatch } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import * as dashboardService from '../../../services/Dashboard';
import { ReactComponent as TuringLogoText } from '../../../assets/img/turing_logo_text.svg';
import accountBox from '../../../assets/img/account-box-new.svg';
import AuthPageLeftWrapper from '../../Common/AuthCommon/AuthPageLeftWrapper';
import AuthPageForm from './AuthPageForm';
import openAi from '../../../assets/img/jobhome/OpenAI.svg';
import anthropic from '../../../assets/img/jobhome/Anthropic.svg'
import dell from '../../../assets/img/jobhome/Dell.svg';
import disney from '../../../assets/img/jobhome/Disney.svg';
import nvidia from '../../../assets/img/jobhome/Nvidia.svg';
import pepsi from '../../../assets/img/jobhome/Pepsi.svg';
import reddit from '../../../assets/img/jobhome/Reddit.svg';
import rivian from '../../../assets/img/jobhome/Rivian.svg';
import snowFlake from '../../../assets/img/jobhome/Snowflake.svg';
import { useLogin } from '../../../containers/Auth/hooks/useLogin';
import { useSignup } from '../../../containers/Auth/hooks/useSignup';
import AuthActions from '../../../actions/Auth';
import { getGCSUrl } from '../../../services/Common';
import CompanyCarousel from '../../Common/Carousel/CompanyCarousel';


export const AUTH_TO_SHOW = {
    LOGIN: 'signIn',
    SIGNUP: 'signUp'
}
const AuthComponent = (props) => {
    const [authFormToShow, setAuthFormToShow] = useState(AUTH_TO_SHOW.SIGNUP);
    const [avatarUrl, setAvatarUrl] = useState(null);
    const dispatch = useDispatch();
    const { location, btnLoading, checkAccountExistsStatus, onContinue, authenticationData, updateStateAuthData, setAuthenticationData } = props;
    const loginProps = useLogin(
        (payload) => dispatch(AuthActions.authenticate(payload)),
        (payload) => dispatch(AuthActions.tokenExpired(payload)),
        false
    );
    const signupProps = useSignup(
        (payload) => dispatch(AuthActions.authenticate(payload)),
        (payload) => dispatch(AuthActions.tokenExpired(payload)),
        location,
        false
      );
    const items = [
        { image: openAi, name: 'OpenAI' },
        { image: anthropic, name: 'Anthropic' },
        { image: dell, name: 'Dell' },
        { image: disney, name: 'Disney', style: {height: '50px'} },
        { image: nvidia, name: 'Nvidia' },
        { image: pepsi, name: 'Pepsi', style: {height: '50px'} },
        { image: reddit, name: 'Reddit' },
        { image: rivian, name: 'Rivian' },
        { image: snowFlake, name: 'Snowflake' }

    ];

    const onLogout = useCallback(() => {
        localStorage.clear();
        setAuthenticationData({})
    }, []);

    const onAuthSuccessCallback = (userExists) => {
        updateStateAuthData()
        if (checkAccountExistsStatus && typeof checkAccountExistsStatus === 'function') {
            checkAccountExistsStatus(userExists)
        }
    }

    useEffect(() => {
        if (authenticationData.uid) {
            const getAvatar = async () => {
                try {
                    const res = await dashboardService.getUserSidebarData();
                    const data = res.data.data || {};
                    const avatar = data.avatar;
                    if (avatar) {
                        setAvatarUrl(`${getGCSUrl()}/avatar/${avatar}`)
                    }
                } catch(e) {
                    console.log(e)
                }
            }
            getAvatar()
        }
    }, [authenticationData])

    

    return (
        <div className='job-landing-page__auth-wrapper'>
            {
                authenticationData.uid ? (
                    <div className='job-page-card px-40 pt-52'>
                        <div className='job-landing-page__auth-wrapper-card'>
                            <TuringLogoText />
                            <div className='job-landing-page__auth-wrapper-card-info'>
                                <h4>Welcome back</h4>
                                <div className='authenticated-user-info'>
                                    <div className='authenticated-user-info__img-wrapper'><img src={avatarUrl || accountBox} alt="Avatar" /></div>
                                    <div className='authenticated-user-info__name-wrapper'>
                                        {authenticationData.name ? <span className='authenticated-user-info__name'>{authenticationData.name}</span> : null}
                                        <span>{authenticationData.email}</span>
                                    </div>
                                </div>
                                <Button disabled={btnLoading} onClick={onContinue} colors={{ backgroundColor: '#2F6AE3', color: '#fff' }}>
                                   Continue application {" "} {btnLoading && <span className='continue-spinner'><Spinner $color="#fff" $size={SIZE.small} /></span>}
                                </Button>
                            </div>
                            <p>Not you? <span aria-roledescription='logout button' role="button" className='logout-link' onClick={onLogout}>Log out</span></p>
                        </div>
                    </div>
                ) : (
                    <div className="job-page-card px-40 pt-52 auth-page__left-container">
                        <AuthPageLeftWrapper>
                                {authFormToShow === AUTH_TO_SHOW.LOGIN ? (
                                    <AuthPageForm
                                        type={AUTH_TO_SHOW.LOGIN}
                                        title="Welcome back"
                                        {...props}
                                        onSwitchForm={setAuthFormToShow}
                                        onSubmit={loginProps.handleSubmit}
                                        onSubmitWithSocialAccount={loginProps.handleSocialLogin}
                                        errorMessage={loginProps.errorMessage}
                                        loading={loginProps.loading}
                                        resetError={loginProps.resetError}
                                        onAuthSuccessCallback={onAuthSuccessCallback}
                                    />
                                ) : (
                                    <AuthPageForm
                                        type={AUTH_TO_SHOW.SIGNUP}
                                        title="Create an account"
                                        {...props}
                                        onSwitchForm={setAuthFormToShow}
                                        onSubmit={signupProps.handleSubmit}
                                        onSubmitWithSocialAccount={signupProps.handleSocialLogin}
                                        errorMessage={signupProps.errorMessage}
                                        loading={signupProps.loading}
                                        resetError={signupProps.resetError}
                                        onAuthSuccessCallback={onAuthSuccessCallback}
                                    />
                                )}
                        </AuthPageLeftWrapper>
                    </div>
                )
            }
            <div className='job-landing-page__auth-wrapper-carousel'>
                <div className='job-page-card px-32'>
                    <CompanyCarousel />
                </div>
            </div>
        </div>
    )
}

AuthComponent.propTypes = {
    checkAccountExistsStatus: PropTypes.func,
    location: PropTypes.object,
    onContinue: PropTypes.func,
    authenticationData: PropTypes.object,
    updateStateAuthData: PropTypes.func,
    setAuthenticationData: PropTypes.func,
    btnLoading: PropTypes.bool
}

export default withRouter(AuthComponent)